// Mas información en https://www.npmjs.com/package/react-icomoon
import React from "react";
import IcoMoon, { IconProps } from "react-icomoon";
import { Colors } from "../theme/theme";
import iconSet from "./selection.json";


export type Icons = typeof iconSet;

// const IconName = (iconSet as Icons).icons.map((icon) => icon.properties.name);
// type IconNames = keyof typeof IconName
// IconNames

export const Icon = (props: IconProps) =>
    <IcoMoon
        data-testid={props.icon}
        style={{
            // marginRight: 16
        }}
        size={24}
        color={Colors.primary}
        iconSet={iconSet}
        {...props}
    />;

